export const HOMEPAGE_Images = {
  Self_Service_Sign_up: 'images/home/Self_Service_Sign_up@2x.png',
  Multi_Dwelling_Unit_Sign_Up: 'images/home/Multi-Dwelling_Unit_Sign_Up@2x.png',
  Pre_Registration: 'images/home/Pre-Registration@2x.png',
  Captive_Portal_for_Disconnect:
    'images/home/Captive_Portal_for_Disconnect@2x.png',
  Kiosk: 'images/home/Kiosk@2x.png',
  Existing_Customer_Support: 'images/home/Existing_Customer_Support@2x.png',
  Gardenwall: 'images/home/Gardenwall@2x.png',

  //Currently Default is pre-registration

  DEFAULT_IMAGE: 'images/home/default@2x.png',
};

export const HOMEPAGE_DETAILS = {
  'self-service-signup': {
    image: HOMEPAGE_Images.Self_Service_Sign_up,
    description:
      'Easily sign up for services on your own, without needing customer support.',
    className: 'self-service-signup',
  },
  'multi-dwelling-signup': {
    image: HOMEPAGE_Images.Multi_Dwelling_Unit_Sign_Up,
    description: 'Sign up for service in your apartment or condo.',
    className: 'multi-dwelling-signup',
  },
  'pre-registration': {
    image: HOMEPAGE_Images.Pre_Registration,
    description: 'Get a head start and streamline your event access.',
    className: 'pre-registration',
  },
  'captive-portal-disconnect': {
    image: HOMEPAGE_Images.Captive_Portal_for_Disconnect,
    description:
      'Portal manages temporary network access timeouts and disconnections.',
    className: 'captive-portal-disconnect',
  },
  kiosk: {
    image: HOMEPAGE_Images.Kiosk,
    description: 'Automated services through interactive kiosks.',
    className: 'kiosk',
  },
  'existing-customer-support': {
    image: HOMEPAGE_Images.Existing_Customer_Support,
    description: 'Dedicated support for current customers.',
    className: 'existing-customer-support',
  },
  gardenwall: {
    image: HOMEPAGE_Images.Gardenwall,
    description:
      'A secure, private network solution designed for gated communities and large residential complexes.',
    className: 'gardenwall',
  },
  mdu: {
    image: HOMEPAGE_Images.Existing_Customer_Support,
    description:
      'A tailored sign-up and service management solution for apartments, condos, and shared living spaces.',
    className: 'multi-dwelling-signup',
  },
  //Currently Default is pre-registration
  default: {
    image: HOMEPAGE_Images.DEFAULT_IMAGE,
    description: 'No description available.',
    className: 'default-workflow-image',
  },
};
